// extracted by mini-css-extract-plugin
export default {"IconButton":"iconButton_IconButton__HjGGv"};